import './GlobalStyles.module.scss'

function GlobalStyles({children}) {
    return children
}

export default GlobalStyles;